import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * True below the `md` breakpoint (900 px): phones and upright iPads.
 *
 * The one width signal for the portal's phone layouts. Pages and shared
 * components choose between their desktop and phone layouts from this hook
 * only, so the cutoff lives in one place. `noSsr` reads the media query on
 * the first render, so a phone never flashes the desktop layout.
 *
 * Unit tests stub `matchMedia` to never match (src/test/setup.ts), so tests
 * render the desktop layout unless a test opts in.
 */
export function useIsPhone(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
}
